import pxToRem from "@/theme/functions/pxToRem";

export const SIDEBAR_WIDTH = pxToRem(250);
export const NAVBAR_HEIGHT = pxToRem(70);
